import React from 'react';

export const mainMenuInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-rocket mr-2' />
        Nuestra primera parada es en el <span className='text-success'>Menú principal</span>, que agrupa funciones generales así como específicas de las dependencias de la empresa.
    </p>
    <p className='m-0 mb-2'>
        <i className='fas fa-info mr-2' />
        Si necesitas buscar un usuario, registrar una fuga, georeferenciar, etc., acércate a este menú.
    </p>
</div>

export const indentificationInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-rocket mr-2' />
        A continuación tenemos la opción de <span className='text-success'>Identificación</span>;
        actívala para poder consultar la información de algún elemento del mapa dando clic sobre él.
</p>
</div>;

export const googleAutocompleteInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-rocket mr-2' />
        El siguiente elemento es el <span className='text-success'>Buscador de Google</span>;
        con él, podrás ubicar direcciones, así como los lugares y establecimientos
        más conocidos de la ciudad.

    </p>
</div>

export const userMenuInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-rocket mr-2' />
        A continuación tenemos el <span className='text-success'>Menú de usuario</span>;
        un pequeño menú dónde encontrarás una opción para cambiar tu contraseña y para cerrar sesión.
    </p>
</div>

export const sidebarInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-rocket mr-2' />
        Ahora nos encontramos en el <span className="text-success">Menú lateral</span>. Aquí, podrás
        consultar la leyenda, imprimir una porción del plano, realizar mediciones, etc.
    </p>
    <p className='m-0 py-2 bg-light rounded'>
        <i className='fas fa-arrow-alt-circle-right mr-2' />
        Continuemos para conocer cada una de las opciones de este componente.
    </p>
</div>

export const capasInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Capas</span>
        <i className='fas fa-layer-group ml-2' />; donde hallarás las capas
        con las que cuenta la empresa, organizadas en grupos temáticos.
    </p>
</div>

export const tareasInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Tareas</span>
        <i className='fas fa-tasks ml-2' />; que es el espacio
        donde la mayoría de las tareas que se pueden hacer con
        el sistema se llevarán acabo.
    </p>
</div>

export const medicionInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Medición</span>
        <i className='fas fa-ruler-vertical ml-2' />; con la que
        podrás ejecutar mediciones tanto de distancias como de superficies.
    </p>
</div>

export const info = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Información</span>
        <i className='fas fa-info ml-2' />; donde podrás ver
        la información relevante que se dispone de cualquier
        elemento de las capas.
    </p>
</div>

export const leyendaInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Leyenda</span>
        <i className='far fa-list-alt ml-2' />; que podrás usar
        para consultar el significado de los símbolos en el mapa.
    </p>
</div>

export const impresionInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Impresión</span>
        <i className='fas fa-print ml-2' />; para exportar una porción del mapa en un archivo con formato PDF.
    </p>
</div>

export const reportesInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">Reportes de capas</span>
        <i className='fas fa-file-alt ml-2' />; que reune una serie de informes
        relacionados a las capas.
    </p>
</div>

export const streetViewInfo = <div>
    <p className='m-0 mb-2'>
        <i className='fas fa-check-circle mr-2' />Opción <span className="text-success">StreetView</span>
        <i className='fa fa-street-view ml-2' />; para ver imágenes panorámicas de la ciudad gracias
        al servicio de Street View de Google.
</p>
</div>